"use client";

import { c as _c } from "react/compiler-runtime";
import * as Sentry from "@sentry/nextjs";
import "../../sentry.client.config";
import { useSession } from "next-auth/react";
import type React from "react";
import { useEffect } from "react";
export const ClientSentryMiddleWare = t0 => {
  const $ = _c(5);
  const {
    children
  } = t0;
  const {
    data: session
  } = useSession();
  let t1;
  let t2;
  if ($[0] !== session) {
    t1 = () => {
      if (session) {
        Sentry.setUser({
          id: session.user.id,
          email: session.user.email,
          username: session.user.name
        });
      }
    };
    t2 = [session];
    $[0] = session;
    $[1] = t1;
    $[2] = t2;
  } else {
    t1 = $[1];
    t2 = $[2];
  }
  useEffect(t1, t2);
  let t3;
  if ($[3] !== children) {
    t3 = <>{children}</>;
    $[3] = children;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  return t3;
};